import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import HorizontalBar from '../../components/HorizontalBar';
import useDashboardFilterFields from '../../hooks/useDashboardFilterFields';
import {
  INITIAL_MARKETING_CHANNELS_FILTERS_VALUES,
  MARKETING_CHANNELS_ADDITIONAL_FIELDS,
} from '../../constants';
import TPGrid from 'components/TP-UI/TPGrid';
import Table from 'modules/common/Table';

const MarketingChannelsView = ({ form, loading, items = [], onChange, onExport }) => {
  const fields = useDashboardFilterFields({
    form,
    additionalFilters: MARKETING_CHANNELS_ADDITIONAL_FIELDS,
  });
  const sum = items.reduce((result, item) => result + item.count, 0);
  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        onClick: () => {},
      },
      scales: {
        yAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              callback: (value) => {
                return value && sum > 0 ? Math.round((value / sum) * 100) + '%' : '';
              },
              beginAtZero: true,
            },
            gridLines: {
              offsetGridLines: false,
            },
          },
        ],
      },
    }),
    [sum],
  );

  const filters = useMemo(
    () => ({
      fields: fields,
      form,
      initialValues: INITIAL_MARKETING_CHANNELS_FILTERS_VALUES,
      maxPrimaryFilters: 5,
    }),
    [form, fields],
  );

  const fileActions = useMemo(
    () => [
      {
        label: 'Export',
        onClick: onExport,
      },
    ],
    [onExport],
  );

  return (
    <Table
      items={items}
      view="custom"
      filters={filters}
      fileActions={fileActions}
      loading={loading}
      onChange={onChange}
      scrollable={false}
      noMatchesText="No registered users for this time period"
      hidePagination>
      <TPGrid container direction="column" spacing={2}>
        <TPGrid item>
          <HorizontalBar
            label="Registered Users"
            labelKey="data"
            dataKey="count"
            items={items}
            options={options}
          />
        </TPGrid>
      </TPGrid>
    </Table>
  );
};

MarketingChannelsView.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.array,
  form: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
};

export default MarketingChannelsView;
